import React, { useState } from "react";
import { itinerary } from "../mock";
import Reveal from "./Reveal";
import { MapPin, ChevronDown } from "lucide-react";

const Itinerary = () => {
  const [open, setOpen] = useState(1);

  return (
    <section id="itinerary" className="section bg-paper relative">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="text-center mb-14">
            <span className="font-script text-[#c9a55c] text-3xl block mb-2">day by day</span>
            <h2 className="font-display text-[#1a3a2e] text-4xl md:text-5xl mb-4">
              The <em className="italic text-[#c9a55c]">Itinerary</em>
            </h2>
            <div className="flex items-center justify-center gap-4 text-[#3b463f]/80 text-sm flex-wrap">
              <span>10 Days &amp; 9 Nights</span>
              <span className="w-1 h-1 rounded-full bg-[#c9a55c]" />
              <span>Departs Dec 3, 2026</span>
              <span className="w-1 h-1 rounded-full bg-[#c9a55c]" />
              <span>London → Paris</span>
            </div>
          </div>
        </Reveal>

        <div className="relative">
          {/* timeline line */}
          <div className="absolute left-[22px] top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#c9a55c]/40 to-transparent hidden sm:block" />

          <div className="space-y-4">
            {itinerary.map((d, idx) => {
              const isOpen = open === idx;
              return (
                <Reveal key={d.day} delay={idx * 40}>
                  <div
                    className={`day-card relative bg-[#fdfaf2] border border-[#1a3a2e]/10 rounded-sm sm:ml-14`}
                  >
                    {/* timeline dot */}
                    <div className="absolute -left-[60px] top-7 w-[28px] h-[28px] rounded-full bg-[#1a3a2e] border-4 border-[#faf5ec] hidden sm:flex items-center justify-center text-[#e9c987] text-[10px] font-semibold">
                      {idx}
                    </div>

                    <button
                      onClick={() => setOpen(isOpen ? -1 : idx)}
                      className="w-full text-left p-6 flex items-start justify-between gap-4"
                    >
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2 flex-wrap">
                          <span className="text-[10px] tracking-[0.3em] uppercase text-[#c9a55c] font-semibold">
                            {d.day}
                          </span>
                          <span className="text-[#1a3a2e]/30">|</span>
                          <span className="text-[12px] text-[#3b463f]/70">{d.date}</span>
                        </div>
                        <h3 className="font-display text-[#1a3a2e] text-2xl md:text-[28px] mb-2 leading-tight">
                          {d.title}
                        </h3>
                        <div className="inline-flex items-center gap-1.5 text-[#3b463f]/70 text-sm">
                          <MapPin className="w-3.5 h-3.5 text-[#c9a55c]" strokeWidth={1.5} />
                          {d.location}
                        </div>
                      </div>
                      <ChevronDown
                        className={`w-5 h-5 text-[#1a3a2e] shrink-0 mt-2 transition-transform duration-300 ${
                          isOpen ? "rotate-180" : ""
                        }`}
                        strokeWidth={1.5}
                      />
                    </button>
                    <div
                      className={`overflow-hidden transition-[max-height] duration-500 ${
                        isOpen ? "max-h-96" : "max-h-0"
                      }`}
                    >
                      <div className="px-6 pb-6">
                        <ul className="space-y-3 pl-4 border-l-2 border-[#c9a55c]/40">
                          {d.bullets.map((b, i) => (
                            <li
                              key={i}
                              className="text-[#3b463f] text-[15px] leading-relaxed font-light"
                            >
                              {b}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Itinerary;
